var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolferHalfIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "#ff6633"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1178_2503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5727 55.2588C41.4253 55.2588 46.1698 50.5094 46.1698 44.6506C46.1698 38.7919 41.4253 34.0425 35.5727 34.0425C29.7202 34.0425 24.9757 38.7919 24.9757 44.6506C24.9757 50.5094 29.7202 55.2588 35.5727 55.2588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2006 29.4584C77.889 29.0984 77.5173 28.8104 77.0738 28.6064C75.5034 27.8744 73.4895 28.4624 72.4466 30.0824C72.4226 30.1184 72.3747 30.1304 72.3387 30.1304C57.51 26.1344 42.6814 22.1503 27.8407 18.1543C26.654 17.8423 25.3713 17.9983 24.3524 18.6703C23.2135 19.4263 22.3864 20.5303 22.0987 21.8023C21.7271 23.4223 22.2186 25.2344 23.2975 26.3264C23.6331 26.6624 24.3524 27.3824 25.1795 27.1904C25.8868 27.0344 26.2584 26.3024 26.3423 26.1224C26.8817 24.1184 27.4332 22.0903 27.9846 20.0743C42.5975 23.9384 57.2223 27.8024 71.8352 31.6665C70.6604 34.2225 69.4857 36.7785 68.2989 39.3346C68.2389 39.3466 68.167 39.3706 68.0951 39.3946C67.7954 39.5026 67.5916 39.6466 67.5676 39.6706C67.3159 39.8506 53.9497 48.1547 35.3809 59.6989C34.9254 60.0589 33.7267 61.1269 33.2591 62.9389C32.9834 64.0309 33.0673 64.9549 33.1752 65.519C35.9923 75.4311 38.8094 85.3312 41.6145 95.2434L19.7611 129.9C18.3106 132.204 18.9939 135.264 21.2955 136.716C22.1107 137.232 23.0217 137.484 23.9208 137.484C25.5631 137.484 27.1575 136.668 28.1045 135.18L50.9528 98.9274L51.0008 133.068C51.0008 135.792 53.2185 138 55.9397 138C55.9397 138 55.9397 138 55.9517 138C58.6728 138 60.8905 135.78 60.8786 133.056C60.8546 118.536 60.8426 104.028 60.8186 89.5073C59.3921 82.5712 58.6369 78.8391 57.2104 71.903C57.1984 71.879 57.2104 71.843 57.2343 71.819C60.5549 67.559 63.8874 63.3109 67.208 59.0629C67.3639 58.8589 67.4957 58.6429 67.6036 58.4029C71.2958 50.0027 74.988 41.5906 78.6801 33.1905C79.2196 31.9425 79.0877 30.4664 78.2006 29.4584ZM61.6817 54.3588C59.5479 55.4268 57.4141 56.5068 55.2804 57.5748C55.2804 56.8548 55.2804 56.1228 55.2804 55.4028C57.9776 53.7468 60.6748 52.1028 63.372 50.4467C62.8086 51.7548 62.2451 53.0508 61.6817 54.3588Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1178_2503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(19 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolferHalfIconRound);
export default __webpack_public_path__ + "static/media/golfer-half-icon-round.4bd94557391fb2376bbb7ca2a7633678.svg";
export { ForwardRef as ReactComponent };